import { render, staticRenderFns } from "./BuyNew.vue?vue&type=template&id=260fc6a2"
import script from "./BuyNew.vue?vue&type=script&lang=js"
export * from "./BuyNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports